module.exports = __webpack_public_path__ + "static/media/track-love-no-more.6c5b8c65.png";